import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteWhyChooseUsItems } from "../../api/apiWhyChooseUs";
import parseError from "../../utils/parseError";

export function useForceDeleteAllWhyChooseUsItems() {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllItemsMutate, isPending } = useMutation({
        mutationFn: massForceDeleteWhyChooseUsItems,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["why-choose-us-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete items");
        },
    });

    return { forceDeleteAllItemsMutate, isPending };
}
